import { useCallback, useRef } from "react";
import { useQuery } from "@apollo/client";
import { featuredCardsGQL, Query } from "@onmo/graphql/graphql";

const pageSize = 3;

export const useFeaturedCards = () => {
  const isFetchingMoreRef = useRef(false);
  const { data: featuredCardsData, fetchMore, loading } = useQuery<{
    featuredCards: Query["featuredCards"];
  }>(featuredCardsGQL, {
    variables: { input: { group: "main", page: { limit: pageSize, offset: 0 } } },
  });
  const homeFeed = featuredCardsData?.featuredCards?.items;
  const total = featuredCardsData?.featuredCards?.total ?? 0;

  const loadMore = useCallback(async () => {
    const offset = homeFeed?.length ?? 0;
    if (isFetchingMoreRef.current || loading || offset >= total) return;

    isFetchingMoreRef.current = true;
    try {
      await fetchMore({
        variables: {
          input: { group: "main", page: { limit: pageSize, offset } },
        },
      });
    } finally {
      isFetchingMoreRef.current = false;
    }
  }, [fetchMore, homeFeed?.length, loading, total]);

  return {
    homeFeed,
    hasMore: (homeFeed?.length ?? 0) < total,
    loadMore,
  };
};
